import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var isGmailAddress = email => email.includes("@gmail");
function hash256(string) {
  return __awaiter(this, void 0, void 0, function* () {
    var utf8 = new TextEncoder().encode(string);
    var hashBuffer = yield crypto.subtle.digest("SHA-256", utf8);
    var hashArray = Array.from(new Uint8Array(hashBuffer));
    var hashHex = hashArray.map(bytes => bytes.toString(16).padStart(2, "0")).join("");
    return hashHex;
  });
}
var normalizeGmail = email => {
  var emailTokens = email.split("@");
  if (emailTokens.length < 2) throw new Error("The email has nothing before the '@' symbol");
  var usernameAddress = emailTokens[0];
  var normalizeUsernameAddress = "";
  for (var char of usernameAddress) {
    //Removing the dot symbol
    if (char === ".") continue;
    //If we come across into a sum symbol, we will break the valuation
    if (char === "+") break;
    normalizeUsernameAddress += char;
  }
  return "".concat(normalizeUsernameAddress, "@").concat(emailTokens[1]);
};
export var hashEmail = emailToNormalize => {
  if (!emailToNormalize || !emailToNormalize.trim()) throw new Error("The email in null or empty");
  var _emailToNormalize = emailToNormalize;
  if (isGmailAddress(_emailToNormalize)) _emailToNormalize = normalizeGmail(emailToNormalize);
  return hash256(_emailToNormalize);
};